import * as actionTypes from "./sort.actionTypes";

const initialState = {
  sort: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SORT: {
      return { ...state, sort: action.payload };
    }

    case actionTypes.RESET: {
      return { ...initialState };
    }

    default:
      return state;
  }
};
